import angular = require("angular");

import { ModelBase, BaseModel, modelModule } from "./model";

export enum AccessTypeBit {
	CanView = 1,
	CanEdit = 2,
	CanAdd = 4,
	CanDelete = 8,
	CanAdmin = 16
}

export class AuthorizationModel extends ModelBase {
	constructor($http: ng.IHttpService, $q: ng.IQService, $log: ng.ILogService, baseModel: BaseModel) {
		super("api/Authorization/", $http, $q, $log, baseModel);
	}

	public getCognitoSettings(code?: string) {
		var deferred: ng.IDeferred<{ PoolID: string; ClientID: string; HostedUI: string; Token: string; AuthFlowType: string }> = this.$q.defer();

		this.$http
			.get<{ PoolID: string; ClientID: string; HostedUI: string; Token: string; AuthFlowType: string }>(this.GetUrl("CognitoSettings"), {
				params: { code },
				headers: {
					Anonymous: true,
				},
			})
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("getCognitoSettings", data);
				deferred.reject(data.data);
			});
		return deferred.promise;
	}

	public getScheduleStatusImportRights() {
		var deferred: ng.IDeferred<boolean> = this.$q.defer();

		this.$http
			.get<boolean>(this.GetUrl("CanScheduleStatusImport"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("getScheduleStatusImportRights", data);
				deferred.reject(data.data);
			});
		return deferred.promise;
	}

	public getCriteriaObjectRights() {
		var deferred: ng.IDeferred<model.ISecurityRights> = this.$q.defer();
		this.$http
			.get<model.ISecurityRights>(this.GetUrl("CriteriaObject"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("getCriteriaObjectRights", data);
				deferred.reject(data.data);
			});
		return deferred.promise;
	}

	public getScheduleStatusUpdateRights() {
		var deferred: ng.IDeferred<boolean> = this.$q.defer();

		this.$http
			.get<boolean>(this.GetUrl("CanScheduleStatusUpdate"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("getScheduleStatusUpdateRights", data);
				deferred.reject(data.data);
			});
		return deferred.promise;
	}

	public getSEKOIAImportRights() {
		var deferred: ng.IDeferred<boolean> = this.$q.defer();

		this.$http
			.get<boolean>(this.GetUrl("CanSEKOIAImport"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("CanSEKOIAImport", data);
				deferred.reject(data.data);
			});
		return deferred.promise;
	}

	public getIssueRights(ownerId: number) {
		var deferred: ng.IDeferred<model.ISecurityRights> = this.$q.defer();

		this.$http
			.get<model.ISecurityRights>(this.GetUrl("Issue"), {
				params: {
					resourceOwnerId: ownerId,
				},
			})
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("getIssueRights", data);
				deferred.reject(data.data);
			});

		return deferred.promise;
	}

	public getIssueImpactScenarioRights(ownerId: number) {
		var deferred: ng.IDeferred<model.ISecurityRights> = this.$q.defer();

		this.$http
			.get<model.ISecurityRights>(this.GetUrl("IssueImpactScenario"), {
				params: {
					resourceOwnerId: ownerId,
				},
			})
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("getIssueImpactScenarioRights", data);
				deferred.reject(data.data);
			});

		return deferred.promise;
	}

	public getArcFlashEquipStateRights() {
		var deferred: ng.IDeferred<model.ISecurityRights> = this.$q.defer();

		this.$http
			.get<model.ISecurityRights>(this.GetUrl("ArcFlashEquipState"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("getArcFlashEquipStateRights", data);
				deferred.reject(data.data);
			});

		return deferred.promise;
	}

	public hasAccessToInvestmentAcceleratorImport(parentAssetId: number) {
		var deferred: ng.IDeferred<model.ISecurityRights> = this.$q.defer();
		if (parentAssetId === null || parentAssetId === undefined) {
			deferred.resolve({
				CanView: true,
				CanEdit: false,
				CanDelete: false,
				CanAdd: false,
			});
		} else {
			this.$http
				.get<model.ISecurityRights>(this.GetUrl("InvestmentAcceleratorImport"), {
					params: {
						parentAssetId: parentAssetId,
					},
				})
				.then((data) => {
					deferred.resolve(data.data);
				})
				.catch((data) => {
					this.LogError("hasAccessToInvestmentAcceleratorImport", data);
					deferred.reject(data.data);
				});
		}
		return deferred.promise;
	}

	public hasAccessToIssuesManagement() {
		var deferred: ng.IDeferred<boolean> = this.$q.defer();
		this.$http
			.get<boolean>(this.GetUrl("HasAccessToIssuesManagement"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("hasAccessToIssuesManagement", data);
				deferred.reject(data.data);
			});
		return deferred.promise;
	}

	public hasAccessToAssetExplorer() {
		var deferred: ng.IDeferred<boolean> = this.$q.defer();
		this.$http
			.get<boolean>(this.GetUrl("HasAccessToAssetExplorer"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("HasAccessToAssetExplorer", data);
				deferred.reject(data.data);
			});
		return deferred.promise;
	}

	private getAssetAccessRightsCacheGlobalDeferreds: ng.IDeferred<model.IAssetAccessControl>[] = [];
	private getAssetAccessRightsCacheGlobal: model.IAssetAccessControl = null;

	public getAssetAccessRights(assetID?: number) {
		var deferred: ng.IDeferred<model.IAssetAccessControl> = this.$q.defer();

		if (assetID === undefined || assetID === null) {
			if (this.getAssetAccessRightsCacheGlobal !== null) {
				deferred.resolve(angular.copy(this.getAssetAccessRightsCacheGlobal));
			} else {
				this.getAssetAccessRightsCacheGlobalDeferreds.push(deferred);

				if (this.getAssetAccessRightsCacheGlobalDeferreds.length === 1) {
					this.$http
						.get<model.IAssetAccessControl>(this.GetUrl("AssetAccessRights"))
						.then((data) => {
							this.getAssetAccessRightsCacheGlobal = data.data;
							for (let n of this.getAssetAccessRightsCacheGlobalDeferreds) {
								n.resolve(angular.copy(data.data));
							}
							this.getAssetAccessRightsCacheGlobalDeferreds = [];
						})
						.catch((err) => {
							this.LogError("getAssetAccessRights", err.data);
							deferred.resolve(err.data);
						});
				}
			}
		} else {
			this.$http
				.get<model.IAssetAccessControl>(this.GetUrl("AssetAccessRights"), {
					params: {
						assetId: assetID,
					},
				})
				.then((data) => {
					deferred.resolve(data.data);
				})
				.catch((err) => {
					this.LogError("getAssetAccessRights", err.data);
					deferred.resolve(err.data);
				});
		}
		return deferred.promise;
	}

	public hasAccessToNDimensional() {
		var deferred: ng.IDeferred<boolean> = this.$q.defer();
		this.$http
			.get<boolean>(this.GetUrl("HasAccessToNDimensional"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("hasAccessToNDimensional", data);
				deferred.reject(data.data);
			});
		return deferred.promise;
	}

	public canEditUserManagedTile() {
		var deferred: ng.IDeferred<boolean> = this.$q.defer();

		this.$http
			.get<boolean>(this.GetUrl("CanEditUserManagedTile"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("canEditUserManagedTile", data);
				deferred.reject(data.data);
			});
		return deferred.promise;
	}

	public canAddAssetAccessRole() {
		var deferred: ng.IDeferred<boolean> = this.$q.defer();

		this.$http
			.get<boolean>(this.GetUrl("CanAddAssetAccessRole"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("canAddAssetAccessRole", data);
				deferred.reject(data.data);
			});
		return deferred.promise;
	}

	public canConfigureAlerts() {
		var deferred: ng.IDeferred<boolean> = this.$q.defer();

		this.$http
			.get<boolean>(this.GetUrl("CanConfigureAlerts"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("canConfigureAlerts", data);
				deferred.reject(data.data);
			});
		return deferred.promise;
	}

	public getBetaPermissions() {
		var deferred: ng.IDeferred<model.ISecurityRights> = this.$q.defer();
		this.$http
			.get<model.ISecurityRights>(this.GetUrl("Beta"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("getBetaPermissions", data);
				deferred.reject(data.data);
			});
		return deferred.promise;
	}

	public getUIPermissions() {
		var deferred: ng.IDeferred<model.IResourceAccessType[]> = this.$q.defer();
		this.$http
			.get<model.IResourceAccessType[]>(this.GetUrl("UI"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("getUIPermissions", data);
				deferred.reject(data.data);
			});
		return deferred.promise;
	}

	public getPreviewPermissions() {
		var deferred: ng.IDeferred<model.AdvancedPreview[]> = this.$q.defer();
		this.$http
			.get<model.AdvancedPreview[]>(this.GetUrl("AdvancedPreview"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("getPreviewPermissions", data);
				deferred.reject(data.data);
			});
		return deferred.promise;
	}

	public canConfigureWorkflow() {
		var deferred: ng.IDeferred<boolean> = this.$q.defer();

		this.$http
			.get<boolean>(this.GetUrl("CanConfigureWorkflow"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("CanConfigureWorkflow", data);
				deferred.reject(data.data);
			});
		return deferred.promise;
	}

	public canRunRAScenarioCalcs() {
		const deferred: ng.IDeferred<boolean> = this.$q.defer();

		this.$http
			.get<boolean>(this.GetUrl("CanRunRiskScenarioCalculations"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("CanRunRiskScenarioCalculations", data);
				deferred.reject(data.data);
			});

		return deferred.promise;
	}

	public timeoutSetting() {
		var deferred: ng.IDeferred<number> = this.$q.defer();

		this.$http
			.get<number>(this.GetUrl("TimeoutSetting"))
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("timeoutSetting", data);
				deferred.reject(data.data);
			});

		return deferred.promise;
	}
}

modelModule.factory("authorizationModel", ["$http", "$q", "$log", "baseModel", ($http, $q, $log, baseModel) => new AuthorizationModel($http, $q, $log, baseModel)]);



// WEBPACK FOOTER //
// ./Common/Models/AuthorizationModel.ts